<template>
<div>
  <select class="form-control"
          name="select-time"
          tabindex="0"
          title="Select time"
          aria-label="Select time"
					v-model="time">
    <option v-for="(time, index) in times"
            :value="time.value"
            :key="index">
    {{ time.label }}
    </option>
  </select>
</div>
</template>
<script>

export default {
  name: 'time-picker',
  props: ['format'],
  computed: {
    when () {
      return this.$store.getters['tripPlanner/inputs'].when.type;
    },
    time: {
      get: function() {
        let time = this.$store.getters['tripPlanner/inputs'].when.time;
        let hr = time.split(":")[0]
        let min = time.split(":")[1]
        let dateTS = moment().hour(hr).minute(0)
        let ceiledMin = Math.floor((parseInt(min)+0) / 15) * 15
        dateTS.add(ceiledMin, 'minute');
        return dateTS.format("HH:mm")
      },
      set: function( val ) {
        this.$store.commit('tripPlanner/SET_INPUT_TIME', val);
      }
    },
    formatSetting () {
      return (this.format ? this.format : 'h:mm a')
    },
    times () {
      let result = []
      let dt = moment()
      for (let hr = 0; hr < 24; hr++) {
        for (let min = 0; min < 4; min++) {
          dt.hour(hr).minute(min*15)
          result.push({ value: dt.format('HH:mm'), label: dt.format(this.formatSetting) })

        }
      }
      return result
    }
  },
  watch: {
    when (val) {
      if (val === 'now') {
        this.time = moment().format('HH:mm')
      }
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/TimePicker.vue